import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-keywords',
  templateUrl: './keywords.component.html',
  styleUrls: ['./keywords.component.scss']
})
export class KeywordsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('initKeywords...');
    return new Promise((resolve, reject) =>{ resolve({succes: true})});
  }

}
